
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { logout, mudarMensagens } from '../actions/AppActions';
import { connect } from 'react-redux';

import moment from 'moment-timezone';
import { URL } from '../variables';
import { languages, getSelectedLanguage } from '../languages';

class Chat extends Component {

    constructor(props) {
        super(props);
        this.state = {
            menu: false,
            redirect: false,
            path: '/',
            texto: '',
            chat_open: false,
            alunos: {},
            aluno_select: { mensagens: [] },
            comunicados: [],
            name_filter: '',
            selectedLanguage: getSelectedLanguage()
        };
        this.messages_view = React.createRef();
        this.clearTimeoutMovement = {}
    }

    listen_channels(){
        this.props.socket.on("send_msg_avaliador", function (data) {
            console.log(data)
            if (data.admin_id != this.admin_id) {
                let alunos = [ ...this.props.alunos ];
                let aluno = alunos.filter((item)=>item.id==data.aluno_id)[0];
                if (aluno != undefined) {

                    aluno.mensagens.push({
                        message: data.msg,
                        sala_id: data.sala_id,
                        sender: { id: data.aluno_id, name: data.nome_chat },
                        sender_id: data.aluno_id,
                        uuid: data.id_msg,
                        warning: false,
                        created_at: moment().format('YYYY-MM-DD HH:mm:ss')

                    });
                    aluno.order = moment().unix();
                    // this.setState({ alunos });
                   if (this.props.id_candidato == data.aluno_id && (this.props.chat_open == 0 || this.props.show_chat_meet==true)) {
                        aluno.counter = 0;
                        alunos = alunos.map((item)=>{
                            if(item.id==aluno.id){
                                return aluno;
                            }
                            return item;
                        })
                        if (this.messages_view.current.scrollTop + parseInt(this.messages_view.current.style.height.replace('px', '')) == this.messages_view.current.scrollHeight) {
                            setTimeout(() => {
                                this.messages_view.current.scrollTop = this.messages_view.current.scrollHeight;
                            }, 100);
                        }
                        this.props.mudarState({ alunos });
                        this.props.socket.emit('msg_receive_aluno', { avaliador:true,sala_id: data.sala_id, aluno_id: data.aluno_id, uuid: data.id_msg, faculdade_id: this.props.faculdade.id });
                    }
                    else if(data.from_admin!=true || aluno.name.includes('Chat Geral')) {
                        aluno.counter += 1;
                        alunos = alunos.map((item)=>{
                            if(item.id==aluno.id){
                                return aluno;
                            }
                            return item;
                        })
                        this.props.mudarState({ alunos });
                    }
                    else{
                        alunos = alunos.map((item)=>{
                            if(item.id==aluno.id){
                                return aluno;
                            }
                            return item;
                        })
                        this.props.mudarState({ alunos });
                    }
                }

            }
        }.bind(this));

        

        this.props.socket.on("send_warning_behavior_avaliador", function (data) {
            if (data.admin_id != this.admin_id) {

                let alunos = [ ...this.props.alunos ];
                let aluno = alunos.filter((item)=>item.id==data.aluno_id)[0];

                if (aluno != undefined) {

                    aluno.mensagens.push({
                        message: data.msg,
                        sala_id: data.sala_id,
                        sender: { id: data.aluno_id, name: data.nome_chat },
                        sender_id: data.aluno_id,
                        uuid: data.id_msg,
                        warning: true,
                        created_at: moment().format('YYYY-MM-DD HH:mm:ss')
                    });
                    aluno.order = moment().unix();
                    let video_blink = { ...this.props.video_blink }
                    if (this.props.online.includes(data.aluno_id.toString())) {
                        video_blink[data.aluno_id] = data.type == 'in' ? false : true;
                    }
                    else {
                        video_blink[data.aluno_id] = false;
                    }

                    // $('#msg_count
                    // $('#msg_count' + data.aluno_id).addClass('msg_count_warning');
                    // if (this.state.id_candidato == data.aluno_id) {
                    //     aluno.counter = 0;
                    //     alunos = alunos.map((item)=>{
                    //         if(item.id==aluno.id){
                    //             return aluno;
                    //         }
                    //         return item;
                    //     })
                    //     if (this.messages_view.current.scrollTop + parseInt(this.messages_view.current.style.height.replace('px', '')) == this.messages_view.current.scrollHeight) {

                    //         setTimeout(() => {
                    //             this.messages_view.current.scrollTop = this.messages_view.current.scrollHeight;
                    //         }, 200);
                    //     }
                    //     this.props.mudarState({ alunos, video_blink });
                    //     this.props.socket.emit('msg_receive_aluno', { avaliador:true,sala_id: data.sala_id, aluno_id: data.aluno_id, uuid: data.id_msg, faculdade_id: this.props.faculdade.id, warning: true });


                    // }
                    if (this.props.id_candidato == data.aluno_id && (this.props.chat_open == 0 || this.props.show_chat_meet==true)) {
                        aluno.counter = 0;
                        alunos = alunos.map((item)=>{
                            if(item.id==aluno.id){
                                return aluno;
                            }
                            return item;
                        })
                        this.props.mudarState({ alunos, video_blink });
                        this.props.socket.emit('msg_receive_aluno', {avaliador:true, sala_id: data.sala_id, aluno_id: data.aluno_id, uuid: data.id_msg, faculdade_id: this.props.faculdade.id, warning: true });
                    }
                    else {
                        // aluno.counter += 1;
                        alunos = alunos.map((item)=>{
                            if(item.id==aluno.id){
                                return aluno;
                            }
                            return item;
                        })
                        this.props.mudarState({ alunos, video_blink });
                    }

                }
            }
        }.bind(this));


        this.props.socket.on("msg_receive", function (data) {
            // $('#' + data.id_msg).removeClass();
            // $('#' + data.id_msg).addClass('fas fa-check-double');
            let alunos = [ ...this.props.alunos ];
            let aluno = alunos.filter((item)=>item.id==data.aluno_id)[0];
            
            if (aluno != undefined) {

                for (let i = 0; i < aluno.mensagens.length; i++) {
                    if(data.all==true && aluno.mensagens[i].sender.id==this.props.user.id){
                        aluno.mensagens[i].visto = true;
                    }
                    else if (aluno.mensagens[i].uuid == data.id_msg) {
                        aluno.mensagens[i].visto = true;
                        break;
                    }
                }
                alunos = alunos.map((item)=>{
                    if(item.id==aluno.id){
                        return aluno;
                    }
                    return item;
                })
                this.props.mudarState({ alunos });
            }
        }.bind(this));

        this.props.socket.on("msg_save" + this.admin_id, function (data) {
            // $('#' + data.id_msg).removeClass();
            console.log('save',data)
            let alunos = [ ...this.props.alunos ];
            let aluno = alunos.filter((item)=>item.id==data.aluno_id)[0];

            if (aluno != undefined) {

                for (let i = 0; i < aluno.mensagens.length; i++) {
                    if (aluno.mensagens[i].uuid == data.id_msg) {
                        aluno.mensagens[i].visto = false;
                        break;
                    }
                }
                alunos = alunos.map((item)=>{
                    if(item.id==aluno.id){
                        return aluno;
                    }
                    return item;
                })
                this.props.mudarState({ alunos });
            }
            // $('#' + data.id_msg).addClass('fas fa-check');
        }.bind(this));


    


        this.props.socket.on("msg_receive_comunicado", function (data) {
            return;
            // $('#' + data.id_msg).removeClass();
            // $('#' + data.id_msg).addClass('fas fa-check-double');
            let comunicados = this.props.comunicados;
            console.log(comunicados)
            console.log(data)
            let breaked = false;
            for (let i = 0; i < comunicados.length; i++) {
                if (comunicados[i].id_msg == data.id_msg) {
                    comunicados[i].send = true;
                    breaked = true;
                    break;
                }
            }
            if (breaked == false) {
                comunicados.push({
                    message: data.msg,
                    sala_id: data.sala_id,
                    created_at: moment().format('YYYY-MM-DD HH:mm:ss')
                });
            }
            this.props.mudarState({ comunicados });
        }.bind(this));
    }

    componentDidMount() {
        console.log('mount')
        if (this.messages_view.current) this.messages_view.current.scrollTop = this.messages_view.current.scrollHeight;
        this.admin_id = this.props.admin_id;
        this.languageListener = () => this.setState({ selectedLanguage: getSelectedLanguage() });
        window.addEventListener('avaliador_language_change', this.languageListener);

        this.listen_channels();
        // let aluno_select={};
        // if(this.props.user.role=='fiscal_coordenador'){
        //     aluno_select =  { id: 'comunicado', name: 'Comunicado Geral' };
        // }
        // else{
        //     if(Object.values(this.props.alunos).length>0){
        //         aluno_select =  Object.values(this.props.alunos)[0];
        //     }
        // }
        // // this.props.mudarState({ alunos: this.props.alunos,  comunicados: this.props.comunicados });
        // this.setState({aluno_select});
        
    }
   

    componentWillUnmount() {
        clearTimeout(this.logs_timeout);
        if (this.languageListener) window.removeEventListener('avaliador_language_change', this.languageListener);
    }

    receive_all(uuid, sala_id, aluno_id) {
        fetch(`${URL}api/avaliador/receive_all`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',

                'Authorization': `Bearer ${this.props.token}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                uuid,
                sala_id, aluno_id
            })
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                console.log(resp);
                if (resp.message == "Unauthenticated.") {
                    localStorage.removeItem('token');
                    // this.setState({redirect:true,path:'/'});
                    this.props.logout();
                }
                else {

                }
            } catch (err) {
                console.log(err);
            }

        })
            .catch((err) => {
                console.log(err);
            });
    }


    componentDidUpdate(props) {
        if (props.show_modal_chat_geral == true && this.props.show_modal_chat_geral == false) {
            this.setState({ aluno_select: { mensagens: [] }, });
        }
        
        
    }

    uuidv4() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    send_message() {
        let uid_msg = this.uuidv4();
        let msg = this.state.texto;

        if (msg != null && msg != '' && msg.replace(/ /g, '') != '') {
            let salaId = this.state.aluno_select.sala_id || this.state.aluno_select.sala?.id;
            this.props.socket.emit("send_msg", { processo_id:this.props.processo.id, avaliador:true,msg: msg, sala_id: salaId, aluno_id: this.state.aluno_select.id, nome_chat: this.props.user.name, id_msg: uid_msg, admin_id: this.admin_id, faculdade_id: this.props.faculdade.id });
            // $(this).val('');
            // $('#body_msg').append(template_send.replace(/%MSG%/g,msg).replace(/%ID%/g,uid_msg));
            // $('#body_msg').scrollTop($('#body_msg')[0].scrollHeight);
            let alunos = [ ...this.props.alunos ];
            // let aluno_select={...this.state.aluno_select};
            // aluno_select.mensagens.push({
            //     sender: { id: this.props.user.id, name: this.props.user.name, }, sender_id: this.props.user.id,
            //     receive_id: this.state.aluno_select.id, sala_id:this.state.aluno_select.sala_id, uuid: uid_msg, visto: false, message: msg
            // });
            alunos = alunos.map((item) => {
                if (item.id != this.state.aluno_select.id) return item;
                item.mensagens.push({
                sender: { id: this.props.user.id, name: this.props.user.name, }, sender_id: this.props.user.id,
                receive_id: this.state.aluno_select.id, sala_id: salaId, uuid: uid_msg, visto: undefined, message: msg,
                created_at: moment().format('YYYY-MM-DD HH:mm:ss')
                });
                return item;
            });
            this.setState({ texto: '' });
            this.props.mudarState({ alunos: alunos });
            setTimeout(() => {
                this.messages_view.current.scrollTop = this.messages_view.current.scrollHeight;
            }, 100);
        }
    }

    send_comunicado() {
        let msg = this.state.texto;

        if (msg != null && msg != '' && msg.replace(/ /g, '') != '') {
            let id_msg = this.uuidv4();

            this.props.socket.emit("comunicado_geral", { avaliador:true,id_msg, nome_chat: 'Comunicado Geral', msg: this.state.texto, faculdade_id: this.props.faculdade.id });
            let comunicados = [...this.props.comunicados];
            comunicados.push({
                message: msg,
                id_msg,
                created_at: moment().format('YYYY-MM-DD HH:mm:ss')

            });
            this.props.mudarState({ comunicados: comunicados });
            this.setState({ texto: '' });

        }
    }




    render() {
        let t = languages[this.state.selectedLanguage] || languages.Pt;
        let alunos = Object.values(this.props.alunos);
        alunos = alunos.sort(function (a, b) { return b.order - a.order })
        let online = this.props.online;
        let selected = this.state.aluno_select || { mensagens: [] };
        let messages = selected.id == 'comunicado'
            ? this.props.comunicados.filter((item) => item.sala_id == null)
            : (selected.mensagens || []).filter((item) => item.warning != true);
        return (
            <div className="avaliador-chat-panel avaliador-chat-general">
                <div className="row avaliador-chat-layout">
                    <div className="col-4 avaliador-chat-list">
                        <div className="avaliador-chat-search">
                            <i className="mdi mdi-magnify"></i>
                            <input
                                autoComplete="off"
                                onChange={(e) => this.setState({ name_filter: e.target.value })}
                                value={this.state.name_filter}
                                name="msg"
                                placeholder={t.search_candidate}
                                className="form-control msg_input"
                            />
                        </div>

                        <button type="button" className={"avaliador-chat-thread avaliador-chat-broadcast " + (selected.id == 'comunicado' ? 'active' : '')} onClick={() => {
                            this.setState({ aluno_select: { id: 'comunicado', name: t.general_announcement, mensagens: [] }, texto: '' }, () => {
                                if (this.messages_view.current) this.messages_view.current.scrollTop = this.messages_view.current.scrollHeight;
                            });
                        }}>
                            <div>
                                <h6>{t.general_announcement}</h6>
                                <span>{this.props.comunicados.length > 0 ? this.props.comunicados[this.props.comunicados.length - 1].message : t.room_message}</span>
                            </div>
                            <i className="mdi mdi-bullhorn-outline"></i>
                        </button>

                        {alunos.filter((aluno) => {
                            let filter = this.state.name_filter.toLowerCase();
                            if (filter == '') return true;
                            return (aluno.name || '').toLowerCase().includes(filter) || String(aluno.sala?.numero || aluno.sala || '').toLowerCase().includes(filter);
                        }).map((aluno, id2) => (
                            <button type="button" key={id2} className={"avaliador-chat-thread " + (selected.id == aluno.id ? 'active' : '')} onClick={() => {
                                if (aluno.mensagens.length > 0) {
                                    this.props.socket.emit('msg_receive_aluno', { avaliador: true, sala_id: aluno.sala.id, aluno_id: aluno.id, uuid: aluno.mensagens[aluno.mensagens.length - 1].uuid, faculdade_id: this.props.faculdade.id });
                                    this.receive_all(aluno.mensagens[aluno.mensagens.length - 1].uuid, aluno.sala.id, aluno.id);
                                }
                                let alunosState = this.props.alunos.map((item) => item.id == aluno.id ? { ...item, counter: 0 } : item);
                                this.setState({ aluno_select: { ...aluno, counter: 0 }, texto: '' });
                                this.props.mudarState({ alunos: alunosState });
                                setTimeout(() => {
                                    if (this.messages_view.current) this.messages_view.current.scrollTop = this.messages_view.current.scrollHeight;
                                }, 100);
                            }}>
                                <div>
                                    <h6>{aluno.name}</h6>
                                    <span>{aluno.mensagens.length > 0 ? aluno.mensagens[aluno.mensagens.length - 1].message : `${t.room} ${aluno.sala?.numero || ''}`}</span>
                                </div>
                                <div className="avaliador-chat-thread-meta">
                                    {aluno.counter > 0 && <strong className="avaliador-chat-counter">{aluno.counter}</strong>}
                                    <span className={"avaliador-chat-presence-badge " + (online.includes(aluno.id.toString()) ? 'online' : 'offline')}>
                                        {online.includes(aluno.id.toString()) ? t.online : t.offline}
                                    </span>
                                </div>
                            </button>
                        ))}
                    </div>

                    <div className="col-8 avaliador-chat-conversation">
                        <div className="avaliador-chat-header">
                            <p>{selected.id != undefined ? selected.name : t.select_conversation}</p>
                            <button type="button" className="close" data-dismiss="alert" aria-label="Close" onClick={() => this.props.closeChat()}>
                                <span aria-hidden="true"><i className="mdi mdi-close"></i></span>
                            </button>
                        </div>

                        <div ref={this.messages_view} className="overflow-auto hide-scroll avaliador-chat-messages" id="body_msg">
                            {selected.id == undefined && <div className="avaliador-chat-empty"><i className="mdi mdi-chat-outline"></i><p>{t.select_conversation}</p></div>}
                            {messages.map((item, id) => {
                                let isMine = selected.id == 'comunicado' || (item.receive_id == selected.id && item.sender_id == this.props.user.id);
                                return (
                                    <div key={id} className={"avaliador-message-row " + (isMine ? 'outgoing' : 'incoming')}>
                                        <div className={"avaliador-message-bubble " + (selected.id == 'comunicado' ? 'broadcast' : (isMine ? 'outgoing' : 'incoming'))}>
                                            {!isMine && <p className="avaliador-message-author">{item.sender?.name}</p>}
                                            {selected.id == 'comunicado' && <p className="avaliador-message-author">{t.general_announcement}</p>}
                                            <p>{item.message}</p>
                                            <div className="avaliador-message-meta">
                                                <span>{moment(item.created_at).tz("America/Sao_Paulo").format('DD/MM/YYYY HH:mm')}</span>
                                                {isMine && item.visto == undefined && <i className="fas fa-clock"></i>}
                                                {isMine && item.visto == false && <i className="fas fa-check"></i>}
                                                {isMine && item.visto == true && <i className="fas fa-check-double"></i>}
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>

                        {selected.id != undefined && <div className="avaliador-chat-composer">
                            <input autoComplete="off" onKeyPress={(e) => {
                                let keyCode = e.keyCode || e.which;
                                if (keyCode == 13) {
                                    if (selected.id != 'comunicado') this.send_message();
                                    else this.send_comunicado();
                                }
                            }} onChange={(e) => this.setState({ texto: e.target.value })} value={this.state.texto} name="msg" placeholder={t.message_placeholder} className="form-control msg_input avaliador-chat-input" />
                            <button type="button" className="send_msg" onClick={(e) => {
                                e.stopPropagation();
                                if (selected.id != 'comunicado') this.send_message();
                                else this.send_comunicado();
                            }}>
                                <i className="mdi mdi-send"></i>
                            </button>
                        </div>}
                    </div>
                </div>
            </div>

        );
    }
}
const mapsStateToProps = (state) => (
    {
        tempo_atual: state.AppReducer.tempo_atual,
        processo: state.AppReducer.processo,
        sala: state.AppReducer.sala,
        token: state.AppReducer.token,
        user: state.AppReducer.user,
        socket: state.AppReducer.socket,
        faculdade: state.AppReducer.faculdade,
        chat_open: state.AppReducer.chat_open,
    }
);

export default withRouter(connect(mapsStateToProps, { logout, mudarMensagens })(Chat));
